module.exports = __webpack_public_path__ + "static/media/logo-bw.a2ced9f8.jpg";